import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {frnt} from '@frnt/base/themes'
import {DrawerAppContent} from '../../drawers/drawer-app-content'

const StyledDrawerAppContent = styled(DrawerAppContent)`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media ${frnt.devicePhone}, ${frnt.deviceTablet}, ${frnt.deviceDesktopSmall}, ${frnt.deviceDesktopMedium} {
    background-color: var(--mdc-theme-primary);
  }
  @media ${frnt.deviceDesktopLarge} {
    background-color: var(--mdc-theme-primary2);
  }
`

const DrawerLayout = ({drawer, appBar, children, ...otherProps}) => {
  const HIDDEN = 'hidden'
  const MODAL = 'modal'
  const PERMANENT = 'permanent'
  const DRAWER_TYPES = {
    HIDDEN,
    MODAL,
    PERMANENT
  }
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [drawerType, setDrawerType] = useState()
  const handleResize = () => setDrawerType(calcDrawerType(window.innerWidth))

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [handleResize])

  function calcDrawerType(windowWidth) {
    if (windowWidth === 0) {
      // When there is no window (i.e. SSR), hide the drawer.
      return DRAWER_TYPES.HIDDEN
    } else if (windowWidth < frnt.deviceDesktopLargeMinWidth) {
      return DRAWER_TYPES.MODAL
    } else {
      return DRAWER_TYPES.PERMANENT
    }
  }

  return (
    <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
      <div style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
        <main style={{flex: '1 1', display: 'flex', maxHeight: '100vh'}}>
          {drawerType !== DRAWER_TYPES.HIDDEN && (
            <>
              {React.cloneElement(drawer, {
                modal: drawerType === DRAWER_TYPES.MODAL,
                isDrawerOpen,
                setIsDrawerOpen
              })}
            </>
          )}
          <StyledDrawerAppContent {...otherProps}>
            {drawerType === DRAWER_TYPES.MODAL && (
              // <AppBar isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} />
              <>
                {React.cloneElement(appBar, {
                  isDrawerOpen,
                  setIsDrawerOpen
                })}
              </>
            )}
            {children}
          </StyledDrawerAppContent>
        </main>
      </div>
    </div>
  )
}

DrawerLayout.propTypes = {
  drawer: PropTypes.node.isRequired,
  appBar: PropTypes.node.isRequired,
  children: PropTypes.any
}

export {DrawerLayout}
